/**
 * @flow
 * @relayHash bfe4bb501675797b09aacf01e37c1a60
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type sendContactEmailMutationVariables = {|
  input: {
    name: string,
    company: string,
    address1: string,
    address2?: ?string,
    city: string,
    state: string,
    phone: string,
    fax?: ?string,
    email: string,
    zip: string,
    message: string,
    clientMutationId?: ?string,
  },
|};
export type sendContactEmailMutationResponse = {|
  +sendContactEmail: ?{|
    +success: boolean,
  |},
|};
*/


/*
mutation sendContactEmailMutation(
  $input: sendContactEmailInput!
) {
  sendContactEmail(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "sendContactEmailInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sendContactEmail",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "sendContactEmailInput!"
      }
    ],
    "concreteType": "sendContactEmailPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "sendContactEmailMutation",
  "id": null,
  "text": "mutation sendContactEmailMutation(\n  $input: sendContactEmailInput!\n) {\n  sendContactEmail(input: $input) {\n    success\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "sendContactEmailMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "sendContactEmailMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
(node/*: any*/).hash = '6e6f3fdd49a1f8add16272671f4b4d40';
module.exports = node;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/sendContactEmailMutation.graphql.js